<ul [class]="class">

    <ng-container *ngIf="!userService.loggedIn() || userService.isEmployee()">

        <li class="nav-item nav-item-multilevel">
            <div class="nav-link dropdown dropdown-multilevel-menu no-change-style "
                (mouseleave)="onMouseCategoryEvent()" (mouseenter)="onMouseCategoryEvent()"
                [ngClass]="{'active':currentUrl===path_module_public.advice}">
                <a (click)="onClickToogleCategory($event)" class="btn btn-sm dropdown-toggle font-weight-normal"
                    type="button" role="button" id="dropdownAdCat" data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false">Anuncios</a>
                <div id="dropdownCategory" [class.d-none]="!displayDropdownCategory" class="dropdown-menu"
                    aria-labelledby="dropdownAdCat">
                    <div class="row">
                        <div class="col-md-6">
                            <ul class="main-link-group">
                                <li *ngFor="let e of POSITION_GROUPED">
                                    <a class="dropdown-item" (click)="onClickCategory($event)"
                                        [routerLink]="'/' + path_module_public.advice_category + '/' + e.additional">{{e.parent}}
                                        <ng-container *ngIf="e.count > -1">({{e.count}})</ng-container></a>
                                    <ul>
                                        <li *ngFor="let c of e.items | filterCount : dummyFilterCount">
                                            <a (click)="onClickCategory($event)" class="dropdown-item"
                                                [routerLink]="'/' + path_module_public.advice_category + '/' + e.additional + '/' + c.additional "
                                                target="_self">{{c.child}} <ng-container
                                                    *ngIf="c.count > -1">({{c.count}})</ng-container></a>
                                        </li>
                                        <li>
                                            <a (click)="onClickCategory($event)" class="dropdown-item text-primary"
                                                [routerLink]="'/' + path_module_public.advice_category + '/' + e.additional">Ver
                                                todos
                                                los anuncios ({{e.count}})
                                            </a>
                                        </li>
                                    </ul>
                                </li>


                                <li>
                                    <a (click)="onClickCategory($event)"
                                        class="dropdown-item text-primary link-all-jobs"
                                        [routerLink]="'/' + path_module_public.advice">Ver todos
                                        los anuncios <ng-container *ngIf="countJobs > -1">({{countJobs}})</ng-container>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="align-items-center col-md-6 d-flex">
                            <div class="cta-simple-block no-text-transform">
                                <p>Más de <span class="font-weight-bold text-indigo">{{countJobsRound}}
                                        oportunidades</span>
                                    disponibles
                                    para elegir.<br>Encuentra una perfecta para ti.</p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </li>

        <li class="nav-item">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_INSTITUTION_SEARCH}" class="nav-link"
                [routerLink]="'/'+[constantsService.BASE_PATH_INSTITUTION_SEARCH]">Explorar instituciones</a>

        </li>
        <li class="nav-item">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_SALARIES_VIEW}" class="nav-link"
                [routerLink]="'/'+[constantsService.BASE_PATH_SALARIES_VIEW]">Brújula Salarial</a>
        </li>

    </ng-container>

    <ng-container *ngIf="userService.isEmployee()">

        <li class="d-inline-block d-md-none nav-item">
            <a class="nav-link" [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_EMPLOYEE_RESUME_SEND}"
                [routerLink]="'/'+[constantsService.BASE_PATH_EMPLOYEE_RESUME_SEND]">Enviar currículum</a>
        </li>
        <li class="d-inline-block d-md-none nav-item">
            <a [ngClass]="{'active':currentUrl===constantsService.PATH_EMPLOYEE_APPLICATIONS}" class="nav-link"
                [routerLink]="'/'+[constantsService.PATH_EMPLOYEE_APPLICATIONS]">Mis
                postulaciones</a>
        </li>
        <li class="d-inline-block d-md-none nav-item">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_EMPLOYEE_EDIT}" class="nav-link"
                [routerLink]="'/'+[constantsService.BASE_PATH_EMPLOYEE_EDIT]">Edición de perfil</a>
        </li>
        <li class="d-inline-block d-md-none nav-item">
            <a [ngClass]="{'active':currentUrl===constantsService.PATH_EMPLOYEE_CHAT}" class="nav-link"
                [routerLink]="'/'+[constantsService.PATH_EMPLOYEE_CHAT]">Conversaciones</a>
        </li>
        <li class="d-md-inline-block d-none nav-item">
            <div class="nav-link dropdown">
                <button class="btn btn-sm dropdown-toggle font-weight-normal" type="button" id="dropdownMoreNav"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Mi profeJOBS</button>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMoreNav">
                    <a class="dropdown-item" [routerLink]="'/'+[constantsService.BASE_PATH_EMPLOYEE_RESUME_SEND]">Enviar
                        currículum</a>
                    <a class="dropdown-item" [routerLink]="'/'+[constantsService.PATH_EMPLOYEE_APPLICATIONS]">Mis
                        postulaciones</a>
                    <a class="dropdown-item" [routerLink]="'/'+[constantsService.BASE_PATH_EMPLOYEE_EDIT]">Edición de
                        perfil</a>
                    <a class="dropdown-item" [routerLink]="'/'+[constantsService.PATH_EMPLOYEE_CHAT]">Conversaciones</a>
                </div>
            </div>
        </li>

    </ng-container>

    <ng-container
        *ngIf="(userService.isEmployer() || (userService.isAdminEmployer() &&  userService.getIdEmployer() > 0)) && routeHasAdminAccess === false">

        <li class="nav-item" *appHasAccessModule="profile_access_module.employer_job">
            <a [ngClass]="{'active': [path_module_employer.module, path_module_employer.job_list] | isActiveRoute : currentTs}"
                class="nav-link"
                [routerLink]="['/',path_module_employer.module, path_module_employer.job_list]">Anuncios</a>
        </li>
        <li class="nav-item" *appHasAccessModule="profile_access_module.search_talent">
            <a [ngClass]="{'active': [path_module_employer.module, path_module_employer.search_talent] | isActiveRoute : currentTs}"
                class="nav-link"
                [routerLink]="['/',path_module_employer.module, path_module_employer.search_talent]">Buscar talento</a>
        </li>
        <li class="nav-item" *appHasAccessModule="profile_access_module.employer_psycho_interview">
            <a [ngClass]="{'active': [path_module_employer.module, path_module_employer.psycho_interview] | isActiveRoute : currentTs}"
                class="nav-link "
                [routerLink]="['/',path_module_employer.module, path_module_employer.psycho_interview]">Evaluaciones
                psicolaborales</a>
            <span class="badge badge-primary">Nuevo</span>
        </li>
        <li class="nav-item">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_SALARIES_VIEW}"
                class="nav-link right-separator" [routerLink]="'/'+[constantsService.BASE_PATH_SALARIES_VIEW]">Brújula
                Salarial</a>
        </li>
        <li class="d-inline-block d-md-none nav-item" *appHasAccessModule="profile_access_module.employer_user">
            <a [ngClass]="{'active': [path_module_employer.module, path_module_employer.users] | isActiveRoute : currentTs}"
                class="nav-link"
                [routerLink]="['/',path_module_employer.module, path_module_employer.users]">Usuarios</a>
        </li>
        <li class="d-inline-block d-md-none nav-item">
            <a class="nav-link" href="files/profejobs-manual.pdf" target="_blank">Manual (PDF)</a>
        </li>

        <li class="d-md-inline-block d-none nav-item">
            <div class="nav-link dropdown " [class.right-separator]="userService.isAdminEmployer()">
                <button class="btn btn-sm dropdown-toggle font-weight-normal" type="button" id="dropdownMoreNav"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Mi profeJOBS</button>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMoreNav">

                    <a *appHasAccessModule="profile_access_module.employer_profile" class="dropdown-item"
                        [routerLink]="['/',path_module_employer.module,path_module_employer.edit]">Perfil
                        institucional PRO</a>
                    <a *appHasAccessModule="profile_access_module.employer_user" class="dropdown-item"
                        [routerLink]="['/',path_module_employer.module, path_module_employer.users]">Usuarios</a>
                    <a class="dropdown-item" href="files/profejobs-manual.pdf" target="_blank">Manual (PDF)</a>
                </div>
            </div>
        </li>

    </ng-container>



    <ng-container *ngIf="userService.isAdmin() && routeHasAdminAccess === false">

        <li class="d-inline-block d-md-none nav-item">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_ADMIN_EMPLOYER}" class="nav-link"
                [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_EMPLOYER]">Mantenedor de colegios </a>
        </li>

        <li class="d-inline-block d-md-none nav-item">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_ADMIN_EMPLOYEE}" class="nav-link"
                [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_EMPLOYEE]">Mantenedor de profesores</a>
        </li>

        <li class="d-inline-block d-md-none nav-item">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_ADMIN_SALARIES}" class="nav-link"
                [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_SALARIES]">Mantenedor de salarios</a>
        </li>

        <li class="d-inline-block d-md-none nav-item">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_ADMIN_CUSTOMER_SUCCESS}" class="nav-link"
                [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_CUSTOMER_SUCCESS]">Mantenedor de customer
                success</a>
        </li>
        <li class="d-inline-block d-md-none nav-item">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_ADMIN_PSYCHO_INTERVIEW}" class="nav-link"
                [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_PSYCHO_INTERVIEW]">Evaluaciones psicolaborales</a>
        </li>
        <li class="d-inline-block d-md-none nav-item">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_ADMIN_PROSPECTING}" class="nav-link"
                [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_PROSPECTING]">Prospección</a>
        </li>
        <li class="d-md-inline-block d-none nav-item">

            <div class="nav-link dropdown">
                <button class="btn btn-sm dropdown-toggle font-weight-normal" type="button" id="dropdownMoreNavMant"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Mantenedores</button>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMoreNavMant">
                    <a class="dropdown-item" [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_EMPLOYER]">Colegios</a>
                    <a class="dropdown-item"
                        [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_EMPLOYEE]">Profesores</a>
                    <a class="dropdown-item" [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_SALARIES]">Salarios</a>
                    <a class="dropdown-item"
                        [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_CUSTOMER_SUCCESS]">Customer Success</a>
                    <a class="dropdown-item"
                        [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_PSYCHO_INTERVIEW]">Evaluaciones
                        psicolaborales</a>
                    <a class="dropdown-item"
                        [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_PROSPECTING]">Prospección</a>

                </div>
            </div>
        </li>


        <li class="d-inline-block d-md-none nav-item">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_RECOMENDATION}" class="nav-link"
                [routerLink]="'/'+[constantsService.BASE_PATH_RECOMENDATION]">Algoritmo de recomendación</a>
        </li>
        <li class="d-inline-block d-md-none nav-item">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_SEARCHEMPLOYEE}" class="nav-link"
                [routerLink]="'/'+[constantsService.BASE_PATH_SEARCHEMPLOYEE]">Candidatos</a>
        </li>

        <li class="d-md-inline-block d-none nav-item">

            <div class="nav-link dropdown">
                <button class="btn btn-sm dropdown-toggle font-weight-normal" type="button" id="dropdownMoreNavBusc"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Buscadores</button>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMoreNavBusc">
                    <a class="dropdown-item" [routerLink]="'/'+[constantsService.BASE_PATH_RECOMENDATION]">Algoritmo de
                        recomendación</a>
                    <a class="dropdown-item"
                        [routerLink]="'/'+[constantsService.BASE_PATH_SEARCHEMPLOYEE]">Candidatos</a>
                </div>
            </div>
        </li>


        <li class="nav-item ">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_ADMIN_REPORT}" class="nav-link"
                [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_REPORT]">Reportes</a>
        </li>



    </ng-container>

    <ng-container *ngIf="userService.isAdminEmployer() && routeHasAdminAccess === false">

        <li class="d-inline-block d-md-none nav-item">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_ADMIN_EMPLOYER}" class="nav-link"
                [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_EMPLOYER]">Mantenedor de colegios </a>
        </li>

        <li class="d-inline-block d-md-none nav-item">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_ADMIN_EMPLOYEE}" class="nav-link"
                [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_EMPLOYEE]">Mantenedor de profesores</a>
        </li>

        <li class="d-inline-block d-md-none nav-item">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_ADMIN_SALARIES}" class="nav-link"
                [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_SALARIES]">Mantenedor de salarios</a>
        </li>

        <li class="d-inline-block d-md-none nav-item">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_ADMIN_CUSTOMER_SUCCESS}" class="nav-link"
                [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_CUSTOMER_SUCCESS]">Mantenedor de customer
                success</a>
        </li>

        <li class="d-inline-block d-md-none nav-item">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_ADMIN_PSYCHO_INTERVIEW}" class="nav-link"
                [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_PSYCHO_INTERVIEW]">Evaluaciones psicolaborales</a>
        </li>
        <li class="d-inline-block d-md-none nav-item">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_ADMIN_PROSPECTING}" class="nav-link"
                [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_PROSPECTING]">Prospección</a>
        </li>


        <li class="d-inline-block d-md-none nav-item">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_RECOMENDATION}" class="nav-link"
                [routerLink]="'/'+[constantsService.BASE_PATH_RECOMENDATION]">Algoritmo de recomendación</a>
        </li>
        <li class="d-inline-block d-md-none nav-item">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_SEARCHEMPLOYEE}" class="nav-link"
                [routerLink]="'/'+[constantsService.BASE_PATH_SEARCHEMPLOYEE]">Buscar candidatos</a>
        </li>
        <li class="d-inline-block d-md-none nav-item">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_ADMIN_REPORT}" class="nav-link"
                [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_REPORT]">Reportes</a>
        </li>

        <li class="d-md-inline-block d-none nav-item">

            <div class="nav-link dropdown">
                <button class="btn btn-sm dropdown-toggle font-weight-normal" type="button" id="dropdownMoreNavBusc"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Administración</button>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMoreNavBusc">
                    <a class="dropdown-item" [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_EMPLOYER]">Mantenedor
                        de colegios</a>
                    <a class="dropdown-item" [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_EMPLOYEE]">Mantenedor
                        de profesores</a>
                    <a class="dropdown-item" [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_SALARIES]">Mantenedor
                        de salarios</a>
                    <a class="dropdown-item"
                        [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_CUSTOMER_SUCCESS]">Mantenedor de customer
                        success</a>
                    <a class="dropdown-item"
                        [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_PSYCHO_INTERVIEW]">Evaluaciones
                        psicolaborales</a>
                    <a class="dropdown-item"
                        [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_PROSPECTING]">Prospección</a>


                    <a class="dropdown-item" [routerLink]="'/'+[constantsService.BASE_PATH_RECOMENDATION]">Algoritmo de
                        recomendación</a>
                    <a class="dropdown-item" [routerLink]="'/'+[constantsService.BASE_PATH_SEARCHEMPLOYEE]">Buscar
                        candidatos</a>
                    <a class="dropdown-item" [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_REPORT]">Reportes</a>

                </div>
            </div>
        </li>

    </ng-container>


    <ng-container *ngIf="userService.isAccountant()">
        <li class="nav-item ">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_ADMIN_SALARIES}" class="nav-link"
                [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_SALARIES]">Salarios</a>
        </li>
    </ng-container>

    <ng-container *ngIf="userService.isProspection()">
        <li class="nav-item ">
            <a [ngClass]="{'active':currentUrl===constantsService.BASE_PATH_ADMIN_PROSPECTING}" class="nav-link"
                [routerLink]="'/'+[constantsService.BASE_PATH_ADMIN_PROSPECTING]">Prospección</a>
        </li>
    </ng-container>


</ul>

<ng-container *ngIf="(userService.isAdmin() || userService.isAdminEmployer()) && routeHasAdminAccess === true">


    <div class="row mgn-top-10">
        <div class="col-12">
            <div class="d-flex flex-wrap justify-content-between">
                <div class="alert alert-warning font-size-13 text-dark">
                    <i class="pj-ico pj-ico-170 pj-ico-info text-primary"></i>
                    &nbsp;Estás viendo el perfil de un/a profesor/a desde la cuenta de <b>administrador</b>.
                    &nbsp;<a class="btn btn-primary" role="button" (click)="onClickCloseWindow($event)">Cerrar
                        pestaña</a>
                </div>

            </div>
        </div>
    </div>

</ng-container>